<template>
  <div class="ys-welcome">
    <div class="ys-welcome-main">
      <img :src="logoImg" alt="카이온" class="ys-logo-wordmark ys-logo-wordmark--lg" />
      <p class="ys-welcome-sub">{{ fnaMode ? '회계담당·기관 영수증 관리' : '장기요양 업무 앱' }}</p>

      <div v-if="showInstallCta" class="ys-install-card">
        <p class="ys-install-kicker">{{ fromSms || isSmsFlow ? '문자 링크' : '앱 설치' }}</p>
        <p class="ys-install-title">
          {{ fromSms || isSmsFlow ? '앱을 설치하시겠습니까?' : '앱으로 설치해 주세요' }}
        </p>
        <p class="ys-install-desc">
          Chrome · Safari · 삼성 인터넷 · Edge 등 사용 중인 브라우저에서 홈 화면에 추가할 수 있어요.
        </p>
        <ol v-if="installGuide?.steps?.length" class="ys-install-steps">
          <li v-for="(step, i) in installGuide.steps.slice(0, 3)" :key="i">{{ step }}</li>
        </ol>
        <button type="button" class="ys-btn ys-btn-primary ys-install-btn" @click="onInstallClick">
          {{ primaryInstallLabel }}
        </button>
      </div>
    </div>

    <div class="ys-welcome-actions">
      <button type="button" class="ys-btn ys-btn-primary" @click="$router.push('/login')">
        로그인
      </button>
      <button
        v-if="!fnaMode"
        type="button"
        class="ys-btn ys-btn-ghost"
        @click="$router.push('/signup')"
      >
        회원가입
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import logoImg from '@/assets/images/brand/caion-logo-clear.png'
import { isFnaFlavor } from '@/config/appFlavor'
import {
  captureInstallSourceFromUrl,
  forceShowInstallSheet,
  isSmsInstallFlow,
  openInstallSheet,
  promptInstall,
  scheduleAutoInstallSheet,
  usePwaInstall,
} from '@/composables/usePwaInstall'

const fnaMode = computed(() => isFnaFlavor())

const {
  isInstalled,
  fromSms,
  isSmsFlow,
  installGuide,
  primaryInstallLabel,
  refreshInstalled,
} = usePwaInstall()

const showInstallCta = computed(() => !isInstalled.value)

const onInstallClick = async () => {
  const result = await promptInstall()
  if (result === 'manual' || result === 'external') openInstallSheet()
}

onMounted(() => {
  captureInstallSourceFromUrl()
  refreshInstalled()
  if (isInstalled.value) return

  if (isSmsInstallFlow()) {
    forceShowInstallSheet()
    return
  }
  scheduleAutoInstallSheet(400)
})
</script>
